import { type ConversationVendor } from './ConversationTurnItem'

const AMAZON_BUSINESS_VENDOR_ID = 'amazon-business'

const SourceChannels = {
  AMAZON: 'amazon',
  CATALOG: 'catalog',
} as const

export const deriveSourceChannel = (vendor?: Nullable<ConversationVendor>) =>
  vendor?.id === AMAZON_BUSINESS_VENDOR_ID
    ? SourceChannels.AMAZON
    : SourceChannels.CATALOG
